import { render, staticRenderFns } from "./SmsRoutes.vue?vue&type=template&id=c251b52c&scoped=true&"
import script from "./SmsRoutes.vue?vue&type=script&lang=js&"
export * from "./SmsRoutes.vue?vue&type=script&lang=js&"
import style0 from "./SmsRoutes.vue?vue&type=style&index=0&id=c251b52c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c251b52c",
  null
  
)

export default component.exports